module.exports = __webpack_public_path__ + "assets/img/kv-ac5a9240.jpg";